const timeout = 600;

export default timeout;
